import {ShapeCommand} from '../commands.template';

export class GroupCommand extends ShapeCommand {
  private commands: Array<ShapeCommand>;
  protected services: any;

  constructor(commands: Array<any>) {
    super(
      commands.reduce((acc, curr) => {
        if (curr instanceof ShapeCommand) {
          acc.push(curr);
        }

        return acc;
      }, [])
    );
  }

  public execute() {
    const model = this.services.registrySvc.getGraph().model;

    model.beginUpdate();
    this.object.forEach(command => command.execute());
    model.endUpdate();
  }

  public reverse() {
    const model = this.services.registrySvc.getGraph().model;

    model.beginUpdate();
    const reversed = [].concat(this.object).reverse();

    reversed.forEach(command => command.reverse());
    model.endUpdate();
  }
}
